import React, { useState } from 'react'
import {
  TextInput,
  number,
  required,
  CheckboxGroupInput,
  FormDataConsumer,
} from 'react-admin'
import { get, every, has } from 'lodash'

import {
  Grid,
  Button,
  Typography,
  makeStyles,
  Divider,
} from '@material-ui/core'
import { ResourceSelector } from 'components'
import { numberValidate } from 'utils/formValidations'

import { Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    marginTop: 16,
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },

  buttonsContainer: {
    padding: 8,
  },
})

export const QuestionForm = (props: any) => {
  const { questionIndex } = props
  const classes = useStyles()

  const [questions, setQuestions] = useState([1])
  const [selected, setSelected] = useState<any>('')

  return (
    <>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={2}
        className={classes.container}
      >
        <Grid
          container
          direction="column"
          xs={10}
          sm={10}
          md={10}
          lg={10}
          xl={10}
        >
          <Divider />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography variant="subtitle1" color="textSecondary" gutterBottom>
            Pergunta – {questionIndex + 1}
          </Typography>

          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Typography
              variant="subtitle2"
              color="textPrimary"
            >{`Para a Aula: `}</Typography>
            <Typography variant="caption" color="textSecondary">
              {` Digite uma parte do nome da Aula à qual esta pergunta será vinculada.`}
            </Typography>
          </Grid>

          <Grid container spacing={2} direction="row">
            <TextInput
              style={{
                opacity: 0,
                position: 'absolute',
                pointerEvents: 'none',
              }}
              fullWidth
              label="Tipo"
              source={`grouper[${questionIndex}].type`}
              initialValue="quiz"
              options={{
                value: 'quiz',
              }}
              disabled
            />

            <TextInput
              style={{
                opacity: 0,
                position: 'absolute',
                pointerEvents: 'none',
              }}
              fullWidth
              label="Título"
              source={`grouper[${questionIndex}].title`}
              initialValue="título"
              options={{
                value: 'título',
              }}
              disabled
            />

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <ResourceSelector
                fullWidth
                label="Aula"
                resource="cms/grouper/lesson"
                source={`grouper[${questionIndex}].grouper_id`}
                optionValue="id"
                validate={[required('Obrigatório')]}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3} xl={3}>
              <Tooltip title={'quizzes.order'}>
                <TextInput
                  fullWidth
                  label="Ordem"
                  source={`grouper[${questionIndex}].order`}
                  validate={[
                    required('Obrigatório'),
                    number('Mínimo 2 caracteres numéricos'),
                    numberValidate,
                  ]}
                />
              </Tooltip>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Tooltip title={'quizzes.title'}>
                <TextInput
                  fullWidth
                  label="Enunciado da Pergunta"
                  source={`grouper[${questionIndex}].description`}
                  validate={[required('Obrigatório')]}
                  multiline
                />
              </Tooltip>
            </Grid>
          </Grid>

          <Typography variant="subtitle1" color="primary" gutterBottom>
            Respostas
          </Typography>
          <Grid spacing={2} direction="row" container>
            {!!questions.length &&
              questions.map((option: any, index: number) => {
                return (
                  <Grid
                    key={index}
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                  >
                    <Grid
                      container
                      direction="column"
                      xs={8}
                      sm={8}
                      md={8}
                      lg={8}
                      xl={8}
                    >
                      <Divider />
                    </Grid>
                    <Typography
                      variant="subtitle1"
                      color="textSecondary"
                      gutterBottom
                    >
                      {`Resposta – ${questionIndex + 1}.${index + 1}`}
                    </Typography>

                    <TextInput
                      style={{
                        opacity: 0,
                        position: 'absolute',
                        pointerEvents: 'none',
                      }}
                      fullWidth
                      label="Título"
                      source={`grouper[${questionIndex}].contents.quiz_options[${index}].type`}
                      initialValue="exclusive"
                      options={{
                        value: 'exclusive',
                      }}
                      disabled
                    />

                    <Grid container direction="column">
                      <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                        <Tooltip title={'quizzes.order'}>
                          <TextInput
                            fullWidth
                            label="Ordem"
                            source={`grouper[${questionIndex}].contents.quiz_options[${index}].order`}
                            validate={[
                              required('Obrigatório'),
                              numberValidate,
                              number('Mínimo 2 caracteres numéricos'),
                            ]}
                          />
                        </Tooltip>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Tooltip title={'quizzes.description'}>
                          <TextInput
                            fullWidth
                            label="Texto de Resposta"
                            source={`grouper[${questionIndex}].contents.quiz_options[${index}].description`}
                            multiline
                            validate={[required('Obrigatório')]}
                          />
                        </Tooltip>
                      </Grid>
                      <Grid container spacing={2}>
                        <FormDataConsumer subscription={{ values: true }}>
                          {({ formData, ...rest }) => {
                            let itsValidation: any = [required('Obrigatório')]
                            const questionContents = get(
                              formData,
                              `grouper[${questionIndex}].contents`,
                              [],
                            )

                            const hasCheck = Object.values(
                              questionContents,
                            ).some((option: any) => {
                              const hasCheckInner = option.some(
                                (inner: any) => {
                                  const has = get(
                                    inner,
                                    'correct_option[0]',
                                    false,
                                  )
                                  return has === true
                                },
                              )
                              return hasCheckInner === true
                            })

                            const isChecked = get(
                              formData,
                              `grouper[${questionIndex}].contents.quiz_options[${index}].correct_option[0]`,
                              false,
                            )

                            if (hasCheck) itsValidation = null

                            return (
                              <>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                  <Tooltip title={'quizzes.reason'}>
                                    <TextInput
                                      fullWidth
                                      label="Justificativa"
                                      source={`grouper[${questionIndex}].contents.quiz_options[${index}].reason`}
                                      multiline
                                      disabled={hasCheck && !isChecked}
                                      {...rest}
                                    />
                                  </Tooltip>
                                </Grid>
                                <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                                  <CheckboxGroupInput
                                    label=""
                                    source={`grouper[${questionIndex}].contents.quiz_options[${index}].correct_option`}
                                    choices={[
                                      { id: true, name: 'Resposta Correta' },
                                    ]}
                                    disabled={hasCheck && !isChecked}
                                    {...rest}
                                  />
                                </Grid>
                              </>
                            )
                          }}
                        </FormDataConsumer>
                      </Grid>
                    </Grid>
                  </Grid>
                )
              })}
            <Grid container spacing={2} className={classes.buttonsContainer}>
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() =>
                    setQuestions([...questions, questions.length + 1])
                  }
                >
                  Criar outra Resposta para esta pergunta
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
